import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Magnifier = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M10.3941 11.4548C9.51769 12.1112 8.42925 12.5 7.25 12.5C4.35051 12.5 2 10.1495 2 7.25C2 4.35051 4.35051 2 7.25 2C10.1495 2 12.5 4.35051 12.5 7.25C12.5 8.42925 12.1112 9.51769 11.4548 10.3941L14.5303 13.4697L13.4697 14.5303L10.3941 11.4548ZM11 7.25C11 9.32107 9.32107 11 7.25 11C5.17893 11 3.5 9.32107 3.5 7.25C3.5 5.17893 5.17893 3.5 7.25 3.5C9.32107 3.5 11 5.17893 11 7.25Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Magnifier;
